import { cn } from "@/lib/utils";
import { ReactNode } from "react";

interface PageHeaderProps extends Omit<React.ComponentProps<"div">, "title" | "description"> {
  title: ReactNode;
  titleClassName?: string;
  description?: ReactNode;
  descriptionClassName?: string;
}

export function PageHeader({ title, titleClassName, description, descriptionClassName, children, className, ...props }: PageHeaderProps) {
  return (
    <div className={cn("flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8", className)} {...props}>
      <div className="space-y-0.5">
        <h2 className={cn("font-semibold text-lg", titleClassName)}>{title}</h2>
        {description ? (
          <p className={cn("text-sm text-muted-foreground", descriptionClassName)}>{description}</p>
        ) : null}
      </div>
      {children}
    </div>
  );
}
